import {
  AppNotificationGroupViewDto,
  AppNotificationViewDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export type GetAppNotificationsParams = {
  groupKey?: string;
  'page-start'?: number;
  'page-size'?: number;
};

export const appNotificationRequests = {
  getAppNotificationGroupTypes: EndpointDefinition.get<
    AppNotificationGroupViewDto,
    null
  >({
    name: 'getAppNotificationGroupTypes',
    route: '/notifications/groups',
  }),

  getAppNotificationsForGroup: EndpointDefinition.get<
    AppNotificationViewDto,
    GetAppNotificationsParams
  >({
    name: 'getAppNotificationsForGroup',
    route: '/notifications/guide',
  }),

  loadMoreAppNotificationsForGroup: EndpointDefinition.get<
    AppNotificationViewDto,
    GetAppNotificationsParams
  >({
    name: 'loadMoreAppNotificationsForGroup',
    route: '/notifications/guide',
  }),

  markAppNotificationsAsSeen: EndpointDefinition.patch<
    null,
    {
      notificationIds: number[];
      seen: boolean;
    },
    null
  >({
    name: 'markAppNotificationsAsSeen',
    route: '/notifications/seen',
  }),

  deleteAppNotifications: EndpointDefinition.delete<
    null,
    { notificationIds: number[] }
  >({
    name: 'deleteAppNotifications',
    route: '/notifications',
  }),
};
